module.exports = __webpack_public_path__ + "img/icon-warning-icing-2.abbe8140.svg";